"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SingleLineViewFirstColumn_1 = require("./SingleLineViewFirstColumn");
var SingleLineViewSecondColumn_1 = require("./SingleLineViewSecondColumn");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var SingleLineViewListItem = /** @class */ (function (_super) {
    tslib_1.__extends(SingleLineViewListItem, _super);
    function SingleLineViewListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleLineViewListItem.prototype.render = function () {
        return (React.createElement("div", { className: styles.singleLineViewContainer },
            React.createElement("div", { className: styles.firstRow },
                React.createElement(SingleLineViewFirstColumn_1.default, { firstColumnText: this.props.senderLineTexts, isUnread: this.props.isUnread, isSelected: this.props.isSelected, iconBarUrl: this.props.iconBarUrl, adId: this.props.adId }),
                React.createElement(SingleLineViewSecondColumn_1.default, { isUnread: this.props.isUnread, subjectTexts: this.props.subjectLineTexts, previewTexts: this.props.previewLineTexts, originalPriceTexts: this.props.originalPriceTexts, currentPriceTexts: this.props.currentPriceTexts }))));
    };
    SingleLineViewListItem = tslib_1.__decorate([
        mobx_react_1.observer
    ], SingleLineViewListItem);
    return SingleLineViewListItem;
}(React.Component));
exports.default = SingleLineViewListItem;
//# sourceMappingURL=SingleLineViewListItem.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/SingleLineViewListItem.js
// module id = 5996
// module chunks = 67